<template>
  <b-card body-class="p-2">
    <b-row align-v="center" align-h="between" class="px-2">
      <b-col class="col-lg-3" v-if="ticket.meta && ticket.meta.ticket_media_url">
        <img style="width: 100%;" :src="ticket.meta.ticket_media_url" alt="Media Image" />
      </b-col>
      <b-col class="col-lg-auto">
        <h4>{{ ticket.class_name }}</h4>
        <p v-if="ticket.meta && ticket.meta.custom_schedule" v-html="ticket.meta.custom_schedule" class="mb-1"></p>
        <p v-else class="mb-1">{{ dateRange }}</p>
        <p v-if="ticket.meta && ticket.meta.extra_info" class="mb-1">{{ ticket.meta.extra_info }}</p>
        <p v-if="ticket.meta && ticket.meta.seat_name" class="mb-1">
          <span v-if="ticket.meta.seat_row">{{ trans('row') }}: {{ ticket.meta.seat_row }} - </span>
          {{trans('seat')}}: {{ ticket.meta.seat_name }}
        </p>
        <div v-if="!noNames">
          <b-row v-if="is_editing" class="mb-1">
            <b-col>
              <b-form-input size="sm" v-model="name" @blur="is_editing = false" ref="nameInput"></b-form-input>
            </b-col>
          </b-row>
          <p v-else class="mb-1">
            {{ ticket.participant_name }}
            <b-button v-if="editable" size="sm" variant="link" @click="onEdit" class="p-0">
              <i class="fa fa-fw fa-edit"></i>
            </b-button>
          </p>
        </div>
        <p class="mb-1">
          {{ price }}
          <small v-if="ticket.meta && ticket.meta.extra_price_info">{{ ticket.meta.extra_price_info }}</small>
        </p>
      </b-col>
      <b-col class="text-center align-self-center">
        <img :src="qrCodeUrl" alt="QR Code" style="max-width: 100%; max-height: 160px; aspect-ratio: 1;" />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  export default {
    props: {
      ticket: {
        type: Object,
      },
      editable: {
        type: Boolean,
        default: false
      },
      noNames: {
        type: Boolean,
        default: false
      },
    },
    data(){
      return{
        moment: moment,
        trans: trans,
        name: _.clone(this.ticket.participant_name),
        is_editing: false
      }
    },
    watch: {
      name: {
        handler() {
          if (this.name !== this.ticket.participant_name) {
            this.$emit('name', this.name)
          }
        }
      },
      ticket: {
        deep: true,
        handler() {
          if (this.ticket.participant_name !== this.name) {
            this.name = _.clone(this.ticket.participant_name)
          }
        }
      }
    },
    computed: {
      dateRange(){
        return _.timeRangeStr(moment(this.ticket.start), moment(this.ticket.end))
      },
      price(){
        return this.ticket.price == 0 ? _.upperCase(this.trans('free')): _.currency(this.ticket.price)
      },
      qrCodeUrl() {
        return this.ticket.qr_code_url || '/img/frontend/blocks/qr-code.png'
      }
    },
    methods: {
      onEdit() {
        this.is_editing = true
        this.$nextTick(() => {
          this.$refs.nameInput.focus()
        })
      }
    }
  }
  </script>